import {useContext, useMemo} from "react";
import UserContext from "context/AuthContext";
import {calculateDiscountRate} from "common/price";
import {formattedPrice} from "common/utils";


export const useCouponDiscountedPrice = (product, isBestCouponDiscountUsed) => {
    const couponInfo = useContext(UserContext).couponInfo;
    const myPriceInfo = product?.coupon_discount_infos || product?.my_price_info;

    const bestCouponDiscount = useMemo(() => {
        if (!isBestCouponDiscountUsed) {
            return myPriceInfo ? myPriceInfo.coupon_discount : 0;
        }
        const couponDiscountInfos = myPriceInfo?.coupon_discount_infos !== undefined
            ? myPriceInfo?.coupon_discount_infos : product?.coupon_discount_infos;

        if (!Boolean(couponInfo.coupons) || !Boolean(couponInfo.downloadable_coupons) || !Boolean(myPriceInfo) || !Boolean(couponDiscountInfos)) {
            return 0;
        }
        const availableCouponMoldIds = [
            ...couponInfo.coupons.map(coupon => coupon.coupon_mold_id),
            ...couponInfo.downloadable_coupons.map(coupon => coupon.id),
        ];

        const couponDiscounts = couponDiscountInfos.filter(
            e => !Boolean(e.expires_at) || e.expires_at > (Date.now() / 1000)
        ).filter(
            e => availableCouponMoldIds.includes(e.coupon_mold_id)
        );

        if (couponDiscounts.length === 0) {
            return 0;
        }

        const initialDiscounts = couponDiscounts?.filter(e => !e.is_double_discount).map(e => e.discount);
        const doubleDiscounts = couponDiscounts?.filter(e => e.is_double_discount).map(e => e.discount);

        let maxInitialCouponDiscount = 0;
        let maxDoubleCouponDiscount = 0;

        if (initialDiscounts?.length > 0) {
            maxInitialCouponDiscount = Math.max(...initialDiscounts);
        }

        if (doubleDiscounts?.length > 0) {
            maxDoubleCouponDiscount = Math.max(...doubleDiscounts);
        }

        return Math.min(maxInitialCouponDiscount + maxDoubleCouponDiscount, product.discounted_price);
    }, [couponInfo, myPriceInfo]);

    const discountedPrice = product.discounted_price - bestCouponDiscount;
    const discountRate = calculateDiscountRate(product.price, discountedPrice);
    const discountedPriceText = formattedPrice(discountedPrice, product?.currency);

    return {discountedPrice, discountRate, discountedPriceText};
}
